import assessmentDecisions from "./assessmentDecisions";
import inspectionApplications from "./inspectionApplications";
import inspectionResults from "./inspectionResults";


const assessmentDataService = [
    {
        matcher: 'assessmentData/assessmentDecisions',
        reply: config => {
                const {predicate} = config.params;
                let data;
                if (predicate?.node()?.selector?.() === 'customerName') {
                    const customerName = predicate.node().expectation();
                    const regexp = new RegExp(customerName.replaceAll('*', '.*'));
                    data = assessmentDecisions.filter(assessmentDecision => regexp.test(assessmentDecision.customerName));
                } else {
                    data = assessmentDecisions;
                }
                return [200, data];
        }
    },
    {
        matcher: /assessmentData\/assessmentDecisions\/(.*)/,
        reply: config => {
            const id = /assessmentData\/assessmentDecisions\/(.*)/.exec(config.url)[1];
            const data = assessmentDecisions.find(assessmentDecision => assessmentDecision.id===id);
            return [200, data];
        }
    },
    {
        matcher: 'assessmentData/inspectionApplications',
        reply: config => {
            return [200, inspectionApplications];
        }
    },
    {
        matcher: /assessmentData\/inspectionApplications\/(.*)/,
        reply: config => {
            const uuid = /assessmentData\/inspectionApplications\/(.*)/.exec(config.url)[1];
            const inspectionApplication = inspectionApplications.find(inspectionApplication => inspectionApplication.uuid === uuid);
            return [200, inspectionApplication];
        }
    },
    {
        matcher: 'assessmentData/inspectionResults',
        reply: config => {
            return [200, inspectionResults];
        }
    },
]

export default assessmentDataService;